import React from 'react';
import { Sparkles, BadgeCheck, Globe, Leaf } from 'lucide-react';

const items = [
  { icon: Leaf, label: 'Korean Scalp Science' },
  { icon: Sparkles, label: 'Sulfate-Free Formula' },
  { icon: BadgeCheck, label: 'Clinically Inspired' },
  { icon: Globe, label: 'Made for Every Scalp' },
];

const MarqueeBar = () => {
  const loop = [...items, ...items, ...items, ...items];
  return (
    <div className="w-full overflow-hidden py-4 border-y"
      style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF', borderColor: 'rgba(245,237,223,0.15)' }}>
      <div className="flex animate-marquee whitespace-nowrap gap-12 items-center" style={{ width: 'max-content' }}>
        {loop.map((it, idx) => {
          const Icon = it.icon;
          return (
            <div key={idx} className="flex items-center gap-2 px-4">
              <Icon size={18} strokeWidth={1.5} />
              <span className="text-[14px] tracking-wide font-medium">{it.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MarqueeBar;
